import { combineReducers } from "redux";

import employeeSummaryReducer from "./employees/employee-summary-reducer";
import employeesReducer from "./employees/employees-reducer";
import createInitiatePromotionReducer from "./initiatePromotion/create-initiate-promotion-reducer";
import getInitiatePromotionReducer from "./initiatePromotion/get-initiate-promotion-reducer";

import retirementReducer from "./retirement/retirement-reducer";
import retirementsReducer from "./retirements/retirements-reducer";

import familyInfoReducer from "./employee/family-info-reducer";
import generalInfoReducer from "./employee/general-info-reducer";
import postingsReducer from "./employee/postings-info-reducer";
import qualificationReducer from "./employee/qualifications-reducer";

import attachedFilesReducer from "./employee/attachedFiles-info-reducer";
import servicesReducer from "./employee/services-reducer";

import AcrListReducer from "./acr/acr-list-reducer";
import AprListReducer from "./apr/acr-list-reducer";

import positionReducer from "./position/position-reducer";
import positionsReducer from "./positions/positions-reducer";

import attendancesReducer from "./attendances/attendances-reducer";
import AprReducer from "./employee/apr-reducer";
import providentFundReducer from "./providentFund/provident-fund-reducer";
import providentFundsReducer from "./providentFunds/provident-funds-reducer";

import ACRReducer from "./employee/acr-reducer";
import disciplineReducer from "./employee/discipline-reducer";
import punishmentsReducer from "./punishments/punishments-reducer";
import resignationReducer from "./resignation/resignation-reducer";
import resignationsReducer from "./resignations/resignations-reducer";

import LeaveListReducer from "./leave/leave-list-reducer";
import leaveSummaryReducer from "./leave/leave-summary-reducer";

import gpfHistoryReducer from "./gpfHistory/gpf-history-reducer";
import gpfsReducer from "./gpfs/gpfs-reducer";
import leaveHistoryListReducer from "./leave/leave-history-reducer";
import transfersReducer from "./transfers/transfers-reducer";
import settingsOfficeReducer from "./settings/settingsOfficeReducer";
import userManualReducer from "./settings/userManualReducer";
import positionsInfoReducer from "./positionsInfo/positions-info-reducer";
import interchangeTransfersReducer from "./interchangeTransfers/interchange-transfers-reducer";

const HRMReducers = {
  employees: combineReducers({
    employeeList: employeesReducer,
    employeeSummary: employeeSummaryReducer,
  }),

  employee: combineReducers({
    generalInfo: generalInfoReducer,
    familyInfo: familyInfoReducer,
    qualificationInfo: qualificationReducer,
    postingsInfo: postingsReducer,
    servicesInfo: servicesReducer,
    apr: AprReducer,
    acr: ACRReducer,
    discipline: disciplineReducer,
    attachedFiles: attachedFilesReducer,
  }),

  organization: combineReducers({
    initiatePromotion: combineReducers({
      getInitiatePromotion: getInitiatePromotionReducer,
      createInitiatePromotion: createInitiatePromotionReducer,
    }),
  }),

  retirements: retirementsReducer,
  retirement: retirementReducer,

  position: positionReducer,
  positions: positionsReducer,
  positionsInfo: positionsInfoReducer,

  providentFund: providentFundReducer,
  providentFunds: providentFundsReducer,

  attendances: attendancesReducer,

  punishments: punishmentsReducer,

  acrList: AcrListReducer,
  aprList: AprListReducer,
  resignations: resignationsReducer,
  resignation: resignationReducer,
  leave: combineReducers({
    leaveList: LeaveListReducer,
    leaveSummary: leaveSummaryReducer,
    leaveHistoryList: leaveHistoryListReducer,
  }),
  gpfs: gpfsReducer,
  gpfHistory: gpfHistoryReducer,
  transfers: transfersReducer,
  interchangeTransfers: interchangeTransfersReducer,

  settings: combineReducers({
    officeState: settingsOfficeReducer,
    userManual: userManualReducer,
  }),
};

export default HRMReducers;
